import type {
  PickerData,
  PickerLevelConfig,
} from 'slices/aiConversations/pickerTypes'

const withoutSources = ({
  sources,
  defaultSource,
  ...level
}: PickerLevelConfig): PickerLevelConfig => level

// thanx-ai decides from its own flag read which levels are canonical (no endpoint); the browser flag only changes legacy ones
const gateLevel = (
  level: PickerLevelConfig,
  canonicalPickers: boolean
): PickerLevelConfig =>
  canonicalPickers || level.endpoint === null ? level : withoutSources(level)

/** The picker data ThanxAIPickerV2 loads */
const gatePickerData = (
  data: PickerData,
  canonicalPickers: boolean
): PickerData => ({
  ...data,
  level1: gateLevel(data.level1, canonicalPickers),
  level2: data.level2 && gateLevel(data.level2, canonicalPickers),
})

export default gatePickerData
